<template>
  <div>
    <portal to="toolbar-title"> Αναγγελία Βλάβης</portal>
    <portal to="toolbar-actions"> </portal>
    <div class="new-callout-container">
      <new-callout />
    </div>
  </div>
</template>

<script>
import NewCallout from "../components/NewCallout";

export default {
  name: "AddCallout",
  components: { NewCallout },
};
</script>

<style scoped>

</style>
